import { FolderOverviewEffects, FolderScopesEffects } from './store'

import { EffectsModule } from '@ngrx/effects'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { featureKey } from './store/const'
import { folderOverviewReducers } from './store/reducers'

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, folderOverviewReducers),
    EffectsModule.forFeature([FolderOverviewEffects, FolderScopesEffects]),
  ],
})
export class FolderOverviewNgrxModule {}
